export default {"src":"/_next/static/media/google_icon.66fd9647.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};